import styles from './footer.module.scss';
import { Icon } from '../../atoms/icon';
import { FACEBOOK_URL, LINKEDIN_URL, WEBSITE_URL, YOUTUBE_URL } from '../../../config/constants';

const Footer = () => {
  return (
    <div className={styles.footerContainer}>
      <div className={styles.footerLeft}>
        <span>© {new Date().getFullYear()} Adamantic. Tutti i diritti riservati.</span>
      </div>
      <div className={styles.footerRight}>
        <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
          <Icon content="website" />
        </a>
        <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">
          <Icon content="facebook" />
        </a>
        <a href={LINKEDIN_URL} target="_blank" rel="noopener noreferrer">
          <Icon content="linkedin" />
        </a>
        <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer">
          <Icon content="youtube" />
        </a>
      </div>
    </div>
  );
};

export default Footer;
